function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "avatar-zaika-2x-a",
  width: 95,
  height: 95,
  rx: 22
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "avatar-zaika-2x-b",
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D08C98",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B7535D",
  offset: "49.687%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C12A34",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "avatar-zaika-2x-c",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#avatar-zaika-2x-a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#avatar-zaika-2x-a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#avatar-zaika-2x-b)",
  mask: "url(#avatar-zaika-2x-c)",
  d: "M88.5 24.114v46.772c0 9.727-7.886 17.614-17.614 17.614h-6.6c-1.87 0-3.384-1.515-3.384-3.383V66.504c0-.51.412-.92.92-.92h15.434c1.234 0 2.234-1 2.234-2.235v-1.42c0-1.24-1-2.24-2.234-2.24H61.823c-.51 0-.92-.42-.92-.92v-3.5c0-.51.41-.92.92-.92H76.7c1.54 0 2.79-1.25 2.79-2.79v-.31c0-1.54-1.25-2.79-2.79-2.79H61.823c-.51 0-.92-.42-.92-.92v-2.49c0-.51.41-.92.92-.92h15.504c1.194 0 2.163-.97 2.163-2.17V40.4c0-1.194-.97-2.163-2.163-2.163H61.823c-.51 0-.92-.41-.92-.92V33.94c0-.552.446-1 .998-1h12.08c2.18 0 3.94-1.76 3.94-3.935v-9.693c0-2.174-1.76-3.936-3.93-3.936H20.77c-2.174 0-3.936 1.76-3.936 3.935v9.7c0 2.18 1.76 3.94 3.936 3.94h11.88c.55 0 .998.45.998 1v3.53c0 .51-.41.92-.92.92h-15.52c-1.102 0-1.995.9-1.995 2v1.9c0 1.11.893 2 1.995 2H32.72c.51 0 .92.42.92.92v2.58c0 .51-.41.92-.92.92H18.787c-1.122 0-2.03.91-2.03 2.03v1.83c0 1.12.908 2.03 2.03 2.03h13.93c.51 0 .922.41.922.92v1.77c0 .39-.26.72-.63.82-3.44.87-10.34 1.78-15.66 1.97-1.03.04-1.84.87-1.84 1.89v1.93c0 1.07.88 1.94 1.95 1.9 5.31-.19 12.15-1.1 15.56-1.96.29-.08.55.18.48.47-.55 2.27-3.1 4.62-10.02 6.1-2.41.52-4.34.77-5.73.9-1.46.13-2.57 1.34-2.57 2.8v2.17c0 1.61 1.35 2.89 2.96 2.81 3.53-.18 8.78-.64 14.38-2.95 7.51-3.1 10.61-10.22 10.61-20.06V33.95c0-.55.45-1 1-1h6.21c.55 0 1 .45 1 1v51.17c0 1.868-1.51 3.383-3.38 3.383H24.11c-9.722 0-17.61-7.887-17.61-17.614V24.11c0-9.724 7.887-17.61 17.614-17.61h46.772c9.728 0 17.614 7.886 17.614 17.614zm-37.972-2.676h-6.513c-.47 0-.85.38-.85.848v4.112c0 .468.38.848.85.848h6.513c.468 0 .848-.38.848-.848v-4.112c0-.468-.38-.848-.848-.848zm17.813 5.808c.47 0 .85-.38.85-.848v-4.112c0-.468-.38-.848-.85-.848h-6.59c-.46 0-.84.38-.84.848v4.112c0 .468.38.848.85.848h6.59zm-41.75-5.808c-.47 0-.85.38-.85.848v4.112c0 .468.38.848.85.848h6.21c.47 0 .85-.38.85-.848v-4.112c0-.468-.38-.848-.84-.848H26.6z"
}));

var SvgZaikaDark = function SvgZaikaDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZaikaDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zaika-dark.a6ec65fe.svg";
export { ForwardRef as ReactComponent };